<div class="d-flex justify-content-center align-items-center min-vh-100 login-taj-theme">
  <div class="login-wrapper">
    <div class="card">
      <div class="card-body p-5">
        <div class="text-center"> <img src="assets/img/icons/user-logo.svg" height="70" width="70" class="icon-user-syle"></div>
        <h2 class="text-center mb-4">Login</h2>
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
          <div class="form-group">
            <label for="username" class="sr-only">Username</label>
            <input type="text" id="username" class="form-control" placeholder="Enter username"
              formControlName="username">
            <div
              *ngIf="loginForm.get('username')?.invalid && (loginForm.get('username')?.dirty || loginForm.get('username')?.touched)"
              class="text-danger mt-1">
              <div *ngIf="loginForm.get('username')?.errors?.['required']">
                Username is required
              </div>
              <div *ngIf="loginForm.get('username')?.errors?.['username']">
                Invalid username format
              </div>
            </div>
          </div>
          <div class="form-group mt-2 mb-2">
            <label for="password">Password</label>
            <input type="password" class="form-control" id="password" placeholder="Enter password"
              formControlName="password">
            <div
              *ngIf="loginForm.get('password')?.invalid && (loginForm.get('password')?.dirty || loginForm.get('password')?.touched)"
              class="text-danger mt-1">
              <div *ngIf="loginForm.get('password')?.errors?.['required']">
                Password is required
              </div>
              <div *ngIf="loginForm.get('password')?.errors?.['minlength']">
                Password should be at least 6 characters long
              </div>
            </div>
          </div>
          <div class="form-group form-check">
            <input type="checkbox" class="form-check-input" id="rememberMe" formControlName="rememberMe">
            <label class="form-check-label" for="rememberMe">Remember me</label>
          </div>
          <div class="form-group text-center mb-2 mt-3">
            <button type="submit" class="md-btn-primary" [disabled]="!loginForm.valid">Submit</button>
          </div>
          <div class="form-group text-center">
            <!-- <a routerLink="/forget-password">Forgot Password?</a> -->
            <a href="#" class="hyperlink-cl">Forgot Password?</a>
          </div>
          <div *ngIf="errorMessage" class="text-danger mt-3">
            {{ errorMessage }}
          </div>
        </form>
      </div>
    </div>
  </div>
</div>